import * as yup from "yup";

export const createValidationSchema = yup.object().shape({
  code: yup
    .string()
    .min(2, "Mã kho phải có ít nhất 2 ký tự")
    .required("Vui lòng nhập mã kho"),
  name: yup
    .string()
    .min(2, "Tên kho phải có ít nhất 2 ký tự")
    .required("Vui lòng nhập tên kho"),
  type: yup.string().required("Vui lòng nhập loại kho"),
  description: yup.string().optional(),
});
